import {combineReducers} from 'redux'
import storage from 'redux-persist/lib/storage'
import {AuthSlices} from './auth/slices'

import {persistReducer} from 'redux-persist'
import {UserSlices} from './users/slices'
import {CommonSlices} from './common/slices'
import {GroupSlices} from './groups/slices'
import {ProjectSlices} from './projects/slices'
import {EventSlices} from './events/slices'
import {SiteSlices} from './sites/slices'
import {AssetSlices} from './assets/slices'
import {TemplateSlices} from './templates/slices'
import {SubscriptionPlanSlices} from './subscription_plans/slices'
import {InspectionCompanySlices} from './inspection_companies/slices'
import {ConfigurationSlices} from './configurations/slices'
import {FrequencySlices} from './frequencies/slices'
import {TagSlices} from './tags/slices'
import {OrderSlices} from './orders/slices'
import {NotificationSlices} from './notifications/slices'
import {TransactionSlices} from './transactions/slices'
import {MyPuchaseSlices} from './my_purchases/slices'
import {TabSlices} from './tabs/slices'
import {categorySlices} from './category/slices'
import {DataAnonymizationSlices} from './data_anonymization/slices'

const authPersistConfig = {
  key: 'auth',
  storage: storage,
}

const systemConfig = {
  key: 'config',
  storage: storage,
}

export const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, AuthSlices.reducer),
  configuration: persistReducer(systemConfig, ConfigurationSlices.reducer),
  common: CommonSlices.reducer,
  categories: categorySlices.reducer,
  users: UserSlices.reducer,
  groups: GroupSlices.reducer,
  projects: ProjectSlices.reducer,
  events: EventSlices.reducer,
  sites: SiteSlices.reducer,
  assets: AssetSlices.reducer,
  templates: TemplateSlices.reducer,
  subscriptionPlans: SubscriptionPlanSlices.reducer,
  inspectionCompanies: InspectionCompanySlices.reducer,
  frequencies: FrequencySlices.reducer,
  tags: TagSlices.reducer,
  orders: OrderSlices.reducer,
  notifications: NotificationSlices.reducer,
  transactions: TransactionSlices.reducer,
  myPurchases: MyPuchaseSlices.reducer,
  tabs: TabSlices.reducer,
  dataAnonymization: DataAnonymizationSlices.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

/*export function* rootSaga() {
  yield all([auth.saga()])
}*/
